<template>
  <div class="app-container">
    <nav class="add-navigation ">
      <div class="row  ">
        <div class="col-md-4 col-12 mb-3" style="margin-top: -6px">
          <date-time-picker
              class="name-starting-margin"
            header="STARTING DATE"
            header_font_size="12"
            header_font_color="#000"
            header_font_weight="900"
            :initial_time="StartDate"
            @getTime="GetStartTime"
          ></date-time-picker>
        </div>
        <div class="col-md-4 col-12 aligned-top "  >
          <search-input
            name='Starting Balance'
            v-model="filters.start_balance"
            placeholder="Balance"
          />
        </div>
      </div>
    </nav>
    <div class="add-container">
      <loader :loading="loading" v-if="loading" />
      <not-found v-else-if="!balance_logs.length" />
      <template v-else>
        <div
          class="table_div"
          style="width: 100%; overflow-x: auto; overflow-y: hidden"
        >
          <table class="Invoice_table">
            <thead>
              <tr class="Invoice_table_header">
                <th rowspan="2">Date</th>
                <th rowspan="2">Payment</th>
                <th colspan="2">DID Charge</th>
                <th colspan="2">SMS Charge</th>
                <th rowspan="2">EOD Balance</th>
              </tr>
              <tr class="Invoice_table_header">
                <th>Count</th>
                <th>Charge</th>
                <th>Count</th>
                <th>Charge</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(log, index) in balance_logs"
                :key="`log-${index}`"
              >
                <th>{{ log.date }}</th>
                <th>{{ log.payment }}</th>
                <th>{{ log.did_count }}</th>
                <th>{{ log.did_charge }}</th>
                <th>{{ log.sms_count }}</th>
                <th>{{ log.sms_charge }}</th>
                <th>{{ log.eod_balanse }}</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
          <div class="per-page">
            <span class="filter_by">Show Per Page:</span>
            <div class="perPage">
              <primary-select
                type="text"
                @input="changePerPage"
                v-model="per_page" :is-cross="false"
              >
                <option
                  v-for="item in pages"
                  :key="item"
                  :value="item"
                >{{ item }}
                </option>
              </primary-select>
            </div>
          </div>
          <div
            class="buttons-wrapper"
            :class="{ pagination: paginationCondition }"
          >
            <pagination-component
              @change-page="changePage($event)"
              :page="Page"
              :total="totalPages"
              :perPage="per_page"
              :qnt="balance_logs.length"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  components: {
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    DateTimePicker: () => import("@/components/DateTime"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue")
  },
  data() {
    return {
      balance_logs: [],
      loading: true,
      Page: 0,
      per_page: 10,
      totalPages: 0,
      pages: [10, 20, 50],
      typing_timeout: null,
      filters: {
        start_date: null,
        start_balance: null
      }
    }
  },
  watch: {
    'filters.start_balance': function () {
      clearTimeout(this.typing_timeout)
      this.typing_timeout = setTimeout(() => {
        this.GetList()
      }, 800)
    }
  },
  computed: {
    paginationCondition() {
      return this.balance_logs.length < this.per_page && this.Page === 0;
    },
    StartDate() {
      return new Date(new Date().setHours(0, 0, 0))
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    GetStartTime(d) {
      this.filters.start_date = new Date(d)

      this.GetList()
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList() {
      // Calling API (API not ready) ==========================================
      this.loading = true

      // this.balance_logs = res.items.map(this.transformLogs) ====== when API is ready using this =======
      this.loading = false
    },
    transformLogs(item) {
      return {
        // need to add value (API not ready) ====================================
        date: format(item, 'YYYY:MM:DD HH:mm:ss'),
        payment: item,
        did_count: item,
        did_charge: item,
        sms_count: item,
        sms_charge: item,
        eod_balanse: item
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  padding: 0 20px;

  .add-navigation {
    margin-top: 20px;
    margin-bottom: 20px;

    .filters {
      width: fit-content;
      display: flex;
      align-items: center;


    }
  }
  .add-container {
    width: 100%;

    .table_div {
      width: 100%;

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(0.44, #51a3f3),
          color-stop(0.72, #51a3f3),
          color-stop(0.86, #51a3f3)
        );
      }
      .Invoice_table {
        min-width: 100%;
        border-collapse: collapse;

        tr {
          width: 100%;
          height: 40px;

          th {
            padding: 0 10px;
            text-align: center;
          }
        }
        .Invoice_table_header {
          background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

          th {
            border: 1px solid #f8f9fe;
            color: #fff;

            .sorting {
              cursor: pointer;
            }
          }
        }
        tbody {
          tr {
            box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            background-color: #ffffff;

            th {
              font-family: "Helvetica Neue";
              font-size: 14px;
              font-weight: normal;
              color: #212b36;
            }
          }
        } 
      }
    }
    .per-page {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .filter_by {
        margin-right: 15px;
        color: #55616e;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .perPage {
        width: 120px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: 100%;

      &.pagination {
        width: fit-content;
        flex-grow: 1;
      }
    }
  }
}
@media screen and (max-width: 1180px) {
  .app-container {
    .add-container {
      .table_div {
        .Invoice_table {
          width: 1080px;
        }
      }
    }
  }
}
.col{
  align-items: center;
}
 .name-starting-margin{
   margin-bottom: 4px;
 }
</style>